module.exports = __webpack_public_path__ + "static/financiado_ue-50da48accd32ecdfb040811d649944b3.png";